<!--
 * @Descripttion: 支付页面组件
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 23:15:35
--> 

<template>
  <div class="payment">
    <div class="payment-content" v-if="order">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="payment-clearfix">
          <span>Pay Order</span>
        </div>
        <div class="payment-item">
          <!-- 订单信息 -->
          <div class="order-summary">
            <div class="summary-row">
              <span class="label">Order Number:</span>
              <span class="value">{{order.order_num}}</span>
            </div>
            <div class="summary-row">
              <span class="label">Product:</span>
              <span class="value">{{order.name}}</span>
            </div>
            <div class="summary-row">
              <span class="label">Quantity:</span>
              <span class="value">{{order.num}}</span>
            </div>
          </div>

          <!-- 未支付状态：显示支付按钮 -->
          <div v-if="order.type==1">
            <div class="payment-tips">
              <p>Scan the QR code using any UPI payment app</p>
              <p>(Google Pay, PhonePe, Paytm, etc.)</p>
            </div>

            <!-- 二维码显示区域 -->
            <div class="qr-section" v-if="qrPayUrl">
              <div class="qr-amount">
                <span>Pay Amount: </span>
                <span class="amount-value">{{qrAmount}}₹</span>
              </div>
              <div class="qr-code-wrapper">
                <img :src="qrImageUrl" alt="QR Code" style="width:250px;height:250px;">
              </div>
              <div class="qr-status" v-if="checkingPayment">
                <i class="el-icon-loading"></i>
                <span>Waiting for payment confirmation...</span>
              </div>
            </div>

            <!-- 支付按钮区域 -->
            <div class="pay-operate" v-if="!qrPayUrl">
              <div class="pay-price">
                <span>Order Amount:</span>
              </div>
              <div class="pay-price-num">
                <span>{{order.discount_price * order.num}}₹</span>
              </div>
              <div class="pay-btn">
                <el-button type="primary" :loading="loading" @click="pay">Pay Now</el-button>
              </div>
            </div>

            <!-- 已显示二维码后的操作按钮 -->
            <div class="qr-actions" v-if="qrPayUrl">
              <el-button @click="cancelPayment">Cancel</el-button>
              <el-button type="primary" @click="checkPaymentStatus">I have paid</el-button>
            </div>
          </div>

          <!-- 已支付状态 -->
          <div v-else class="paid-status">
            <i class="el-icon-success"></i>
            <span>This order has been paid</span>
          </div>
        </div>
      </el-card>
    </div>
    <div class="not-found" v-else>Unable to find the order</div>
  </div>
</template>
<script>
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'
export default {
  name: 'Payment',
  components: {
  },
  data() {
    return {
      orderNum: '',
      order: '',
      loading: false,
      qrPayUrl: '',
      qrAmount: '0',
      checkingPayment: false,
      paymentTimer: null
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
    }
  },
  beforeDestroy() {
    if (this.paymentTimer) {
      clearInterval(this.paymentTimer)
    }
  },
  computed: {
    qrImageUrl() {
      if (!this.qrPayUrl) return ''
      return 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + encodeURIComponent(this.qrPayUrl)
    }
  },
  watch: {
    orderNum: function() {
      this.load()
    }
  },
  methods: {
    load() {
      // 重置二维码状态
      this.qrPayUrl = ''
      this.qrAmount = '0'
      this.checkingPayment = false
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
        this.paymentTimer = null
      }

      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
          } else if (res.status === 20001) {
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    pay() {
      if (!this.order) return

      this.loading = true
      let amount = (parseFloat(this.order.discount_price) * this.order.num).toFixed(2)

      let payForm = {
        order_num: String(this.order.order_num),
        amount: amount,
        nickname: this.$store.getters.getUser.nickname || 'Customer',
        phone: this.order.address_phone || '',
        email: this.order.address_email || ''
      }

      paymentAPI
        .initOnlinePayment(payForm)
        .then(res => {
          this.loading = false
          if (res.status === 200 && res.data && res.data.pay_url) {
            this.qrPayUrl = res.data.pay_url
            this.qrAmount = res.data.amount || amount
            this.checkingPayment = true
            this.startPaymentPolling()
          } else if (res.status === 20001) {
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to create payment', res.msg || res.error)
          }
        })
        .catch(err => {
          this.loading = false
          this.notifyError('Failed to create payment', err)
        })
    },
    startPaymentPolling() {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
      }
      this.paymentTimer = setInterval(() => {
        ordersAPI
          .showOrder(this.orderNum)
          .then(res => {
            if (res.status === 200 && res.data) {
              if (res.data.type === 2) {
                clearInterval(this.paymentTimer)
                this.paymentTimer = null
                this.checkingPayment = false
                this.order = res.data
                this.notifySucceed('Payment successful!')
              }
            }
          })
          .catch(() => {})
      }, 5000)
    },
    checkPaymentStatus() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200 && res.data) {
            if (res.data.type === 2) {
              if (this.paymentTimer) {
                clearInterval(this.paymentTimer)
                this.paymentTimer = null
              }
              this.checkingPayment = false
              this.order = res.data
              this.notifySucceed('Payment successful!')
            } else {
              this.notifyError('Payment not yet received', 'Please complete the payment and try again')
            }
          }
        })
        .catch(err => {
          this.notifyError('Failed to check payment status', err)
        })
    },
    cancelPayment() {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
        this.paymentTimer = null
      }
      this.checkingPayment = false
      this.qrPayUrl = ''
      this.qrAmount = '0'
    }
  },
  created() {}
}
</script>

<style scoped>
.payment .payment-content {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.payment .payment-content .payment-item .order-summary {
  width: 600px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}
.payment .payment-content .payment-item .order-summary .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
}
.payment .payment-content .payment-item .order-summary .summary-row .label {
  color: #757575;
}
.payment .payment-content .payment-item .order-summary .summary-row .value {
  color: #333;
  font-weight: 500;
}

.payment .payment-content .payment-item .payment-tips {
  width: 600px;
  margin: 0 auto;
  text-align: center;
  color: #757575;
}
.payment .payment-content .payment-item .payment-tips p {
  margin: 3px 0;
}

/* 二维码区域 */
.payment .payment-content .payment-item .qr-section {
  text-align: center;
  padding: 20px 0;
}
.payment .payment-content .payment-item .qr-section .qr-amount {
  font-size: 18px;
  margin-bottom: 20px;
}
.payment .payment-content .payment-item .qr-section .qr-amount .amount-value {
  font-size: 28px;
  font-weight: bold;
  color: #ff6700;
}
.payment .payment-content .payment-item .qr-section .qr-code-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.payment .payment-content .payment-item .qr-section .qr-status {
  color: #ff6700;
  font-size: 14px;
  margin-top: 10px;
}
.payment .payment-content .payment-item .qr-section .qr-status i {
  margin-right: 5px;
}

/* 二维码操作按钮 */
.payment .payment-content .payment-item .qr-actions {
  text-align: center;
  padding: 20px 0;
}

.payment .payment-content .pay-operate {
  width: 700px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 60px;
}
.payment .payment-content .pay-operate .pay-price {
  margin-left: 170px;
  height: 20px;
}
.payment .payment-content .pay-operate .pay-price-num {
  font-size: 30px;
  color: #ff6700;
  width: 110px;
  margin-left: 10px;
}
.payment .payment-content .pay-operate .pay-btn {
  height: 30px;
}

/* 已支付状态 */
.payment .payment-content .payment-item .paid-status {
  text-align: center;
  padding: 40px 0;
  color: #67c23a;
  font-size: 18px;
}
.payment .payment-content .payment-item .paid-status i {
  font-size: 40px;
  display: block;
  margin-bottom: 10px;
}

/*v-else*/
.payment .not-found {
  height: 500px;
  text-align: center;
}
/*v-else END*/
</style>
